import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialMove: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 13.71h-1.52v-1.52h-1.52v-1.52H25.9v4.57h-6.09v1.52h6.09v4.57h1.53v-1.52h1.52v-1.52h1.52v-1.53H32v-1.52h-1.53zM16.76 25.9v-6.09h-1.52v6.09h-4.58v1.53h1.53v1.52h1.52v1.53h1.53V32h1.52v-1.52h1.52v-1.53h1.53v-1.52h1.52V25.9zM15.24 0v1.52h-1.53v1.53h-1.52v1.52h-1.53V6.1h4.58v6.09h1.52V6.1h4.57V4.57h-1.52V3.05h-1.53V1.52h-1.52V0zM4.57 10.67v1.52H3.05v1.52H1.52v1.53H0v1.52h1.52v1.53h1.53v1.52h1.52v1.52h1.52v-4.57h6.1v-1.52h-6.1v-4.57z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialMove
